import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "unknow",
  "use": "unknow-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"unknow\"><title>未知</title><path d=\"M6 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm-.08 9.52a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.51.51.51 0 0 1 .51.49.5.5 0 0 1-.51.52zM8.1 4.58c0 .54-.19 1-1 1.8-.42.43-.68.74-.71 1a.42.42 0 0 1-.42.38.42.42 0 0 1-.38-.46 2.66 2.66 0 0 1 1-1.53c.75-.76.77-1 .78-1.25A1.12 1.12 0 0 0 7 3.73a1.32 1.32 0 0 0-1-.41 1.26 1.26 0 0 0-1.26 1.26.43.43 0 0 1-.85 0A2.12 2.12 0 0 1 6 2.48a2.15 2.15 0 0 1 1.57.67 1.88 1.88 0 0 1 .53 1.43z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/unknow.svg
// module id = iAMO
// module chunks = 6